export default "__VITE_ASSET__9YByRa4BU91mMecQ$5q5Rw__"